// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3mt8K","image":"Header_image__3uVOj","name":"Header_name__33_CG","info":"Header_info__dSYzq","infoRow":"Header_infoRow__3y0g7"};